import { render } from "./ApproveAcceptancePageList.vue?vue&type=template&id=9425a0dc&scoped=true"
import script from "./ApproveAcceptancePageList.vue?vue&type=script&lang=ts"
export * from "./ApproveAcceptancePageList.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-9425a0dc"

export default script